// extracted by mini-css-extract-plugin
export default {"buttons":"IncrementButton_buttons__9vCrj","lineText":"IncrementButton_lineText__pUo7s"};